import { gql } from '@apollo/client';

export const TRANSLATE_ACTIVITIES = gql`
  mutation TranslateActivities($input: TranslateActivitiesInput!) {
    translateActivities(input: $input) {
      language
    }
  }
`;
